import { render, staticRenderFns } from "./LabourAssessment.vue?vue&type=template&id=7fbb22e2&scoped=true"
import script from "./LabourAssessment.vue?vue&type=script&lang=js"
export * from "./LabourAssessment.vue?vue&type=script&lang=js"
import style0 from "./LabourAssessment.vue?vue&type=style&index=0&id=7fbb22e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbb22e2",
  null
  
)

export default component.exports